import React, { useState } from 'react';
import { Grid, Box, Button, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {
	AddSearchFlightDispatch,
	fetchCityDispatch,
} from '../../reducers/HomeReducer';
import { DatePicker } from 'antd';
import moment from 'moment';
import {
	setSelectedArrival,
	setSelectedDepart,
} from '../../reducers/UiReducer';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
const { RangePicker } = DatePicker;

const SearchEngineFlight = () => {
	const dispatch = useDispatch();
	const { city } = useSelector((state) => state.home);
	const { depart, arrival, tab } = useSelector((state) => state.ui);
	const [departDate, setDepartDate] = useState('');
	const date = new Date();
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [loading, setLoading] = useState(false);
	const [infant, setInfant] = useState(0);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const handleChange = (event) => {
		let value = event.target.value.toLowerCase();
		let cityData = {
			keywords: value,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
	};
	const dateFormat = 'YYYY/MM/DD';
	function disabledDate(current) {
		// Can not select days before today and today
		// console.log('current', current);

		// return current && current <= moment().endOf('day');
		return moment().add(-1, 'days') >= current;
	}
	const onChange = (date, dateString) => {
		setDepartDate(dateString);
	};
	const onChangeReturn = (date, dateString) => {
		setDepartDateReturn(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};
	const handleCancel = () => {
		setOpen(false);
	};
	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};
	const handleSearch = () => {
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.airport_code,
					Destination: arrival.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		let formData2 = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 2,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.airport_code,
					Destination: arrival.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[0],
				},
				{
					Origin: arrival.airport_code,
					Destination: depart.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[1],
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		if (tab === 'oneway') {
			navigate('/searchresult', { state: formData });
			// dispatch(AddSearchFlightDispatch(formData, navigate));
			// console.log('formData', formData);
		} else {
			navigate(
				depart.country_code === 'IN' && arrival.country_code === 'IN'
					? '/searchresultroundtrip'
					: '/searchresultinternational',
				{ state: formData2 }
			);
			// dispatch(AddSearchFlightDispatch(formData2, navigate));
		}
	};
	console.log('date', date.toISOString().split('T')[0]);
	return (
		<Grid container spacing={1} alignItems={'center'}>
			<Grid item xs={12} sm={12} md={3} lg={3}>
				<Autocomplete
					id='country-select-demo'
					sx={{ width: '100%' }}
					options={city && city.result.length > 0 ? city.result : []}
					autoHighlight
					ListboxProps={{
						className: 'myCustomList',
					}}
					value={depart}
					getOptionLabel={(option) =>
						`${option.airport_code}- ${option.city_name} `
					}
					renderOption={(props, option) => (
						<Box
							component='li'
							sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
							{...props}>
							<img
								loading='lazy'
								width='20'
								src={`https://flagcdn.com/w20/${option.country_code.toLowerCase()}.png`}
								srcSet={`https://flagcdn.com/w40/${option.country_code.toLowerCase()}.png 2x`}
								alt=''
							/>
							<p style={{ fontSize: 14, marginLeft: 5 }}>
								{option.city_name} - {option.airport_code}
							</p>
						</Box>
					)}
					onChange={(event, value) => {
						dispatch(setSelectedDepart(value));
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							id='standard-basic'
							label='Leaving From'
							variant='standard'
							onChange={handleChange}
							style={{ fontSize: 12 }}
							inputProps={{
								...params.inputProps,
								autoComplete: 'new-password', // disable autocomplete and autofill
							}}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={3}>
				<Autocomplete
					id='country-select-demo'
					sx={{ width: '100%' }}
					options={city && city.result.length > 0 ? city.result : []}
					autoHighlight
					ListboxProps={{
						className: 'myCustomList',
					}}
					value={arrival}
					getOptionLabel={(option) =>
						`${option.airport_code}- ${option.city_name} `
					}
					renderOption={(props, option) => (
						<Box
							component='li'
							sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
							{...props}>
							<img
								loading='lazy'
								width='20'
								src={`https://flagcdn.com/w20/${option.country_code.toLowerCase()}.png`}
								srcSet={`https://flagcdn.com/w40/${option.country_code.toLowerCase()}.png 2x`}
								alt=''
							/>
							<p style={{ fontSize: 14, marginLeft: 5 }}>
								{option.city_name} - {option.airport_code}
							</p>
						</Box>
					)}
					onChange={(event, value) => {
						dispatch(setSelectedArrival(value));
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							id='standard-basic'
							label='Going To'
							variant='standard'
							onChange={handleChange}
							style={{ fontSize: 12 }}
							inputProps={{
								...params.inputProps,
								autoComplete: 'new-password', // disable autocomplete and autofill
							}}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={tab === 'oneway' ? 2 : 3}>
				{tab === 'oneway' ? (
					<DatePicker
						disabledDate={disabledDate}
						onChange={onChange}
						// format='DD-MMYYYY'
						// defaultValue={moment(date.toISOString().split('T')[0], dateFormat)}
						// format={dateFormat}
						style={{
							width: '100%',
							padding: 8,
							border: 'none',
							borderBottom: '1px solid',
							marginTop: 9,
							borderRadius: '1px',
							boxShadow: 'none',
						}}
					/>
				) : (
					<RangePicker
						disabledDate={disabledDate}
						onChange={onChangeReturn}
						style={{
							width: '100%',
							padding: 8,
							border: 'none',
							borderBottom: '1px solid',
							marginTop: 9,
							borderRadius: '1px',
							boxShadow: 'none',
						}}
					/>
				)}
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={2}>
				<Button
					onClick={showModal}
					style={{
						textTransform: 'capitalize',
						padding: 7,
						borderBottom: '1px solid',
						width: '100%',
						marginTop: 11,
						borderRadius: 1,
					}}>
					Traveller Class
				</Button>{' '}
				<hr />
				<Modal
					open={open}
					title='Travellers'
					onOk={handleOk}
					onCancel={handleCancel}
					footer={[
						<Button key='back' onClick={handleCancel}>
							OK
						</Button>,
					]}>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}>
						<p>Adults(12+yrs)</p>
						<Box>
							<Button
								onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
									fontWeight: 'bold',
								}}>
								{adult}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? adult : setAdult(adult + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								+
							</Button>
						</Box>
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginTop: 5,
						}}>
						<p>Child(2-11yrs)</p>
						<Box>
							<Button
								onClick={() => (child === 0 ? '' : setChild(child - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
									fontWeight: 'bold',
								}}>
								{child}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? child : setChild(child + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								+
							</Button>
						</Box>
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginTop: 5,
						}}>
						<p>Infant(0-2yrs)</p>
						<Box>
							<Button
								onClick={() => (infant === 0 ? '' : setInfant(infant - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
									fontWeight: 'bold',
								}}>
								{infant}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? infant : setInfant(infant + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								+
							</Button>
						</Box>
					</Box>
				</Modal>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={tab === 'oneway' ? 2 : 1}>
				<Button
					onClick={handleSearch}
					variant='contained'
					style={{
						width: '100%',
						background: 'orange',
						fontWeight: 'bold',
						padding: '7px',
						marginTop: 3,
					}}>
					Search
				</Button>
			</Grid>
		</Grid>
	);
};

export default SearchEngineFlight;
